class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

// class CouponCode extends HTMLElement {
//   constructor() {
//     super();
//     if (localStorage.getItem('storedDiscount')){
//       this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
//     }
//     this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
//       this.val = this.querySelector('input[name="discount"]').value;
//       localStorage.setItem('storedDiscount', this.val);
//       fetch(`/discount/${this.val}`)
//           .then((response) => response.text())
//           .then((responseText) => {
        	
//       });
//       document.querySelector('.popup-toolDown.show').classList.remove('show');
//       document.querySelector('.previewCart').classList.remove('active-tool');
//       Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
//     })
//   }
// }

 class CouponCode extends HTMLElement {
  constructor() {
    super();

    const discountInput = this.querySelector('input[name="discount"]');
    const applyButton = this.querySelector('[data-update-coupon]');

    const storedDiscount = localStorage.getItem('storedDiscount');
    if (storedDiscount && discountInput) {
      discountInput.value = storedDiscount;
    }

    applyButton?.addEventListener('click', async (event) => {
      event.preventDefault();

      const discountCode = discountInput?.value?.trim();
      if (!discountCode) {
        console.warn('[COUPON] Empty discount code');
        return;
      }

      localStorage.setItem('storedDiscount', discountCode);

      try {
        const discountUrl = `/discount/${encodeURIComponent(discountCode)}?redirect=/cart`;
        const startTime = Date.now();

        const response = await fetch(discountUrl, {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'follow'
        });

        await new Promise(resolve => setTimeout(resolve, 500));

        Shopify.getCart((cart) => {
          console.log('[COUPON] Updated cart received');
          console.log('[COUPON] Cart:', cart);

          window.sharedFunctions?.updateSidebarCart(cart);
        });

      } catch (error) {
        console.error('[COUPON] Discount apply failed');
        console.error(error);
      }

      document
        .querySelector('.popup-toolDown.show')
        ?.classList.remove('show');

      document
        .querySelector('.previewCart')
        ?.classList.remove('active-tool');
    });
  }
}

customElements.define('coupon-code', CouponCode);